function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#E6E6E6;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "Path_76",
  className: "st0",
  d: "M24.2,14.4c0-1.3,0.5-2.5,1.4-3.4c0.9-0.9,2.2-1.4,3.5-1.4c0.9,0,1.8,0.3,2.6,0.9V9.8H34v9.3 h-2.4v-0.6c-0.7,0.6-1.6,0.9-2.6,0.9C26.4,19.3,24.2,17.2,24.2,14.4C24.2,14.5,24.2,14.5,24.2,14.4L24.2,14.4z M26.5,14.4 c0,1.4,1.1,2.6,2.6,2.6c1.4,0,2.6-1.1,2.6-2.6c0-0.7-0.3-1.3-0.7-1.8c-1-1-2.6-1-3.6,0c0,0,0,0,0,0C26.8,13.1,26.5,13.8,26.5,14.4z "
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_77",
  className: "st0",
  d: "M34.6,15.2V9.8h2.4v4.8c0,0.6,0.1,1.3,0.4,1.9c0.9,0.8,2.2,0.8,3.1,0c0.3-0.6,0.4-1.2,0.4-1.9 V9.8h2.4v5.5c0.1,1.2-0.3,2.3-1.1,3.1c-1.9,1.3-4.5,1.3-6.4,0C34.9,17.5,34.5,16.4,34.6,15.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_78",
  className: "st0",
  d: "M48.8,14.4c0-1.3,0.5-2.5,1.4-3.4c0.9-0.9,2.2-1.4,3.5-1.4c2.7,0,4.9,2.1,4.9,4.8 c0,0.9-0.2,1.7-0.7,2.5c-0.4,0.7-1,1.4-1.8,1.8c-1.5,0.9-3.4,0.9-4.9,0C49.7,17.8,48.8,16.2,48.8,14.4z M51.1,14.4 c-0.1,1.4,1,2.6,2.4,2.7s2.6-1,2.7-2.4c0-0.1,0-0.1,0-0.2c0-0.7-0.3-1.3-0.7-1.8c-1-1-2.6-1-3.6,0c0,0,0,0,0,0 C51.4,13.1,51.1,13.8,51.1,14.4L51.1,14.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_79",
  className: "st0",
  d: "M59.1,14.4c0-1.3,0.5-2.5,1.4-3.4c0.9-0.9,2.2-1.4,3.5-1.4c0.9,0,1.8,0.3,2.6,0.9V9.8H69v8.6 c0,0.6-0.1,1.3-0.2,1.9c-0.1,0.5-0.3,1-0.5,1.4c-0.2,0.4-0.4,0.7-0.7,1c-0.3,0.3-0.5,0.5-0.9,0.7c-0.3,0.2-0.6,0.3-0.9,0.4 c-0.3,0.1-0.6,0.2-0.9,0.2c-0.3,0-0.6,0-0.8,0c-1.7,0-3.3-0.9-4.1-2.3l2.2-1c0.2,0.3,0.5,0.5,0.9,0.7c0.3,0.2,0.7,0.3,1.1,0.3 c0.7,0,1.4-0.2,1.9-0.7c0.5-0.6,0.8-1.4,0.7-2.2v-0.4C65.9,19,65,19.3,64,19.3C61.4,19.3,59.2,17.2,59.1,14.4 C59.2,14.5,59.2,14.5,59.1,14.4L59.1,14.4z M61.5,14.4c0,1.4,1.1,2.6,2.5,2.6s2.6-1.1,2.6-2.5c0,0,0,0,0,0c0-0.7-0.3-1.3-0.7-1.8 c-1-1-2.6-1-3.6,0c0,0,0,0,0,0C61.8,13.1,61.5,13.8,61.5,14.4L61.5,14.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_80",
  className: "st0",
  d: "M69.7,14.5c0-0.6,0.1-1.3,0.3-1.9c0.2-0.6,0.5-1.1,0.9-1.6c0.4-0.5,0.9-0.8,1.5-1.1 c0.6-0.3,1.3-0.4,2-0.4c0.8,0,1.7,0.2,2.4,0.7c0.7,0.4,1.3,1,1.7,1.8c0.4,0.7,0.6,1.6,0.6,2.4c0,0.3,0,0.5-0.1,0.8h-7 c0.1,0.6,0.4,1.1,0.9,1.4c0.5,0.4,1.1,0.5,1.7,0.5c0.4,0,0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.4,1-0.8l1.6,1.3c-0.4,0.6-1,1.1-1.7,1.4 c-0.7,0.3-1.4,0.5-2.2,0.5c-0.9,0-1.7-0.2-2.5-0.6c-0.7-0.4-1.4-1-1.8-1.7C69.9,16.2,69.7,15.3,69.7,14.5L69.7,14.5z M72.1,13.4 h4.6c-0.1-0.5-0.3-0.9-0.7-1.2c-0.4-0.3-1-0.5-1.5-0.5c-0.5,0-1,0.1-1.5,0.5C72.6,12.5,72.3,12.9,72.1,13.4L72.1,13.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_81",
  className: "st0",
  d: "M80.1,19.1V9.8h2.4v0.7c0.2-0.2,0.4-0.3,0.6-0.4c0.2-0.1,0.5-0.2,0.7-0.3 c0.4-0.1,0.7-0.2,1.1-0.1c0.5,0,1,0.1,1.4,0.2c0.4,0.2,0.9,0.4,1.2,0.7c0.4,0.4,0.7,0.8,0.8,1.3c0.2,0.6,0.3,1.2,0.3,1.9V19h-2.4 v-5c0-1.5-0.6-2.2-1.9-2.2s-1.9,0.7-1.9,2.2v5L80.1,19.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_82",
  className: "st0",
  d: "M89.2,14.5c0-0.6,0.1-1.3,0.3-1.9c0.2-0.6,0.5-1.1,0.9-1.6c0.4-0.5,0.9-0.8,1.5-1.1 c0.6-0.3,1.3-0.4,2-0.4c0.8,0,1.7,0.2,2.4,0.7c0.7,0.4,1.3,1,1.7,1.8c0.4,0.7,0.6,1.6,0.6,2.4c0,0.3,0,0.5-0.1,0.8h-7 c0.1,0.6,0.4,1.1,0.9,1.4c0.5,0.4,1.1,0.5,1.7,0.5c0.4,0,0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.4,1-0.8l1.6,1.3c-0.4,0.6-1,1.1-1.7,1.4 c-0.7,0.3-1.4,0.5-2.2,0.5c-0.9,0-1.7-0.2-2.5-0.6c-0.7-0.4-1.4-1-1.8-1.7C89.4,16.2,89.2,15.3,89.2,14.5z M91.6,13.4h4.6 c-0.1-0.5-0.3-0.9-0.7-1.2c-0.4-0.3-1-0.5-1.5-0.5c-0.5,0-1,0.1-1.4,0.5C92.1,12.5,91.7,12.9,91.6,13.4L91.6,13.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_83",
  className: "st0",
  d: "M99.1,19.1V9.8h2.4v0.7c0.4-0.3,0.9-0.6,1.4-0.7c0.7-0.1,1.4-0.2,2.1-0.2v2.3c-0.5,0-1,0-1.5,0.1 c-0.4,0-0.7,0.1-1,0.3c-0.2,0.1-0.5,0.3-0.6,0.5c-0.1,0.2-0.2,0.4-0.3,0.7c-0.1,0.3-0.1,0.6-0.1,0.9v4.7L99.1,19.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_84",
  className: "st0",
  d: "M105,14.4c0-1.3,0.5-2.5,1.4-3.4c0.9-0.9,2.2-1.4,3.5-1.4c0.9,0,1.8,0.3,2.6,0.9V9.8h2.4v9.3 h-2.4v-0.6c-0.7,0.6-1.6,0.9-2.6,0.9C107.2,19.3,105,17.2,105,14.4C105,14.5,105,14.5,105,14.4L105,14.4z M107.4,14.4 c0,1.4,1.1,2.6,2.6,2.6c1.4,0,2.6-1.1,2.6-2.6c0-0.7-0.3-1.3-0.7-1.8c-1-1-2.6-1-3.6,0c0,0,0,0,0,0 C107.6,13.1,107.4,13.8,107.4,14.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_85",
  className: "st0",
  d: "M120.7,14.5c0-0.6,0.1-1.3,0.3-1.9c0.2-0.6,0.5-1.1,0.9-1.6c0.4-0.5,0.9-0.8,1.5-1.1 c0.6-0.3,1.3-0.4,2-0.4c0.8,0,1.7,0.2,2.4,0.7c0.7,0.4,1.3,1,1.7,1.8c0.4,0.7,0.6,1.6,0.6,2.4c0,0.3,0,0.5-0.1,0.8h-7 c0.1,0.6,0.4,1.1,0.9,1.4c0.5,0.4,1.1,0.5,1.7,0.5c0.4,0,0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.4,1-0.8l1.6,1.3c-0.4,0.6-1,1.1-1.7,1.4 c-0.7,0.3-1.4,0.5-2.2,0.5c-0.9,0-1.7-0.2-2.5-0.6c-0.7-0.4-1.4-1-1.8-1.7C120.9,16.2,120.7,15.3,120.7,14.5z M123.1,13.4h4.6 c-0.1-0.5-0.3-0.9-0.7-1.2c-0.4-0.3-1-0.5-1.5-0.5c-0.5,0-1,0.1-1.5,0.5C123.6,12.5,123.2,12.9,123.1,13.4L123.1,13.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_86",
  className: "st0",
  d: "M131.2,18.7c-0.3-0.3-0.4-0.7-0.4-1.1c0-0.8,0.7-1.5,1.5-1.5c0.4,0,0.8,0.2,1.1,0.4 c0.6,0.6,0.6,1.6,0,2.2c-0.3,0.3-0.7,0.4-1.1,0.4C131.9,19.2,131.5,19,131.2,18.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_87",
  className: "st0",
  d: "M134.5,14.4c0-1.3,0.5-2.5,1.4-3.4c0.9-0.9,2.2-1.4,3.5-1.4c0.9,0,1.8,0.3,2.6,0.9V9.8h2.4v9.3 h-2.4v-0.6c-0.7,0.6-1.6,0.9-2.6,0.9C136.7,19.3,134.5,17.2,134.5,14.4C134.5,14.5,134.5,14.5,134.5,14.4z M136.8,14.4 c0,1.4,1.1,2.6,2.6,2.6c1.4,0,2.6-1.1,2.6-2.6c0-0.7-0.3-1.3-0.7-1.8c-1-1-2.6-1-3.6,0c0,0,0,0,0,0 C137.1,13.1,136.8,13.8,136.8,14.4L136.8,14.4z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_71",
  transform: "translate(115.649 6.99)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_88",
  className: "st0",
  d: "M2.4,5.6v3.2c0,0.8,0.3,1.3,1,1.3c0.2,0,0.4,0,0.6,0s0.3,0,0.5,0l0.2,0v2.1 c-0.6,0.2-1.2,0.3-1.8,0.2c-0.8,0-1.5-0.3-2-0.8C0.2,10.9,0,10.1,0,9.3V5.6L2.4,5.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_89",
  className: "st0",
  d: "M5,2.7v2.4H0V0h2.4v2.7L5,2.7z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_72",
  transform: "translate(43.759 6.897)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_90",
  className: "st0",
  d: "M2.4,5.6v3.2c0,0.8,0.3,1.3,1,1.3c0.2,0,0.4,0,0.6,0c0.2,0,0.3,0,0.5,0l0.2,0v2.1 c-0.6,0.2-1.2,0.3-1.8,0.2c-0.8,0-1.5-0.3-2-0.8C0.2,10.9,0,10.1,0,9.3V5.6L2.4,5.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_91",
  className: "st0",
  d: "M5,2.7v2.4H0V0h2.4v2.7L5,2.7z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_92",
  className: "st0",
  d: "M146.5,8.2c0.4,0,0.8-0.1,1.1-0.4c0.6-0.6,0.6-1.6,0-2.2c-0.3-0.3-0.7-0.4-1.1-0.4 c-0.8,0-1.5,0.6-1.5,1.5c0,0,0,0,0,0.1c0,0.4,0.2,0.8,0.4,1.1C145.7,8.1,146.1,8.2,146.5,8.2L146.5,8.2z"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_244",
  x: 145.3,
  y: 9.8,
  className: "st0",
  width: 2.4,
  height: 9.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_93",
  className: "st0",
  d: "M9.5,14.6v4.5H0V9.6h4.5v5L9.5,14.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_94",
  className: "st0",
  d: "M16.1,7.9v4.5H6.7V2.9h4.5v5H16.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_95",
  className: "st0",
  d: "M14.1,4.9c-0.5-0.5-0.8-1.3-0.8-2c0-1.6,1.3-2.8,2.9-2.8c0.7,0,1.5,0.3,2,0.8 c1.1,1.1,1.1,2.9,0,4.1c-0.5,0.5-1.2,0.8-2,0.8C15.4,5.7,14.6,5.4,14.1,4.9z"
}));

function SvgAiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 148 24",
    style: {
      enableBackground: "new 0 0 148 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiLogo);
export default __webpack_public_path__ + "static/media/aiLogo.4e2c5b8f.svg";
export { ForwardRef as ReactComponent };